import { HttpRequest, HttpMethod } from "./http";

// NotificationProvider (#169) — BO admin promo-notification broadcast.
// Endpoints under /api/v3/notifications (JWT-gated). The BE inserts one
// member_notification row per member asynchronously (audience: "all").
class NotificationProvider extends HttpRequest {
    // GET /api/v3/notifications — list previously-sent broadcasts.
    // params: { page?, per_page? }
    list(params) {
        return this.request(HttpMethod.Get, "/api/v3/notifications", params);
    }
    // POST /api/v3/notifications — create + broadcast a promo notification.
    // body: { title, icon_url?, body, image_url?, link_type("product"|"coupon"),
    //         link_ref?, audience: "all" }
    create(payload) {
        return this.request(HttpMethod.Post, "/api/v3/notifications", payload);
    }
}

export default NotificationProvider;
